import routes from "routes";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import Card from "@mui/material/Card";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// Author page sections

import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";

import { Container, Grid, Box } from "@mui/material";

import BackgroundBlogCard from "examples/Cards/BlogCards/BackgroundBlogCard";
import TransparentBlogCard from "examples/Cards/BlogCards/TransparentBlogCard";
import MKTypography from "components/MKTypography";

const BeneficiosVerano2025 = [
  // 🏕️ CAMPING / COLONIAS (3)
  {
    image: "https://images.trvl-media.com/lodging/5000000/4160000/4158600/4158529/f4f8b4e4.jpg",
    title: "Camping Sindicato Costa Atlántica",
    description: "Acceso libre para afiliados, parrillas, duchas y sectores recreativos.",
    action: {
      type: "internal",
      route: "/beneficios/camping-costa",
      label: "Ver beneficio",
    },
  },
  {
    image:
      "https://media.ambito.com/p/127ff30e696078cbfbfe3877d620b754/adjuntos/239/imagenes/040/437/0040437595/1200x675/smart/colonia-veranojpg.jpg",
    title: "Colonia de Verano Infantil",
    description: "Actividades recreativas para hijos de afiliados de 4 a 12 años.",
    action: {
      type: "internal",
      route: "/beneficios/colonia-verano",
      label: "Inscribirse",
    },
  },
  {
    image:
      "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2a/38/a1/a7/domos-temporada-de-verano.jpg?w=800&h=-1&s=1",
    title: "Camping Serrano",
    description: "Descuento exclusivo en estadías de enero y febrero.",
    action: {
      type: "internal",
      route: "/beneficios/camping-serrano",
      label: "Ver beneficio",
    },
  },

  // ⚽ DEPORTES (3)
  {
    image: "https://infofunes.com.ar/uploads/defe%20infantil%20.jpg",
    title: "Escuela de Fútbol de Verano",
    description: "Clases gratuitas para afiliados y grupo familiar.",
    action: {
      type: "internal",
      route: "/beneficios/futbol-verano",
      label: "Ver beneficio",
    },
  },
  {
    image: "https://www.sindicatodelseguro.com.ar/polideportivo17deoctubre/2024_tenis.jpg",
    title: "Torneos de Tenis Intergremial",
    description: "Participación gratuita con premios para los ganadores.",
    action: {
      type: "internal",
      route: "/beneficios/tenis",
      label: "Ver fechas",
    },
  },
  {
    image: "https://luzyfuerzarosario.com/wp-content/uploads/2023/07/voley.jpg",
    title: "Beach Vóley Afiliados",
    description: "Encuentros deportivos todos los fines de semana de enero.",
    action: {
      type: "internal",
      route: "/beneficios/voley",
      label: "Participar",
    },
  },

  // 🍽️ GASTRONOMÍA / RESTAURACIÓN (6)
  {
    image:
      "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/13/80/e5/39/te-esperamos.jpg?w=900&h=500&s=1",
    title: "Heladería Delizia",
    description: "20% de descuento presentando credencial sindical.",
    action: {
      type: "internal",
      route: "/beneficios/heladeria-delizia",
      label: "Ver descuento",
    },
  },
  {
    image: "https://images.pexels.com/photos/6267/menu-restaurant-vintage-table.jpg",
    title: "Parrilla El Fogón",
    description: "Promoción especial para grupos familiares.",
    action: {
      type: "internal",
      route: "/beneficios/parrilla-fogon",
      label: "Ver descuento",
    },
  },
  {
    image: "https://images.pexels.com/photos/262918/pexels-photo-262918.jpeg",
    title: "Pizzería Don Pan",
    description: "2x1 en pizzas todos los miércoles de verano.",
    action: {
      type: "internal",
      route: "/beneficios/pizzeria-donpan",
      label: "Ver promoción",
    },
  },
  {
    image: "https://images.pexels.com/photos/70497/pexels-photo-70497.jpeg",
    title: "Restaurante Costero Mar Azul",
    description: "Descuento del 15% en menús para afiliados.",
    action: {
      type: "internal",
      route: "/beneficios/mar-azul",
      label: "Ver beneficio",
    },
  },
  {
    image: "https://images.pexels.com/photos/461382/pexels-photo-461382.jpeg",
    title: "Hamburguesería Big Pan",
    description: "Combo especial verano para afiliados.",
    action: {
      type: "internal",
      route: "/beneficios/bigpan",
      label: "Ver promo",
    },
  },
  {
    image: "https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg",
    title: "Cafetería La Espiga",
    description: "Descuento del 25% en desayunos y meriendas.",
    action: {
      type: "internal",
      route: "/beneficios/la-espiga",
      label: "Ver descuento",
    },
  },
];

export default function Verano2025Page() {
  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "/afiliate",
          label: "Afiliate",
          color: "info",
        }}
        transparent
        light
      />
      <MKBox bgColor="white">
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.8),
                rgba(gradients.dark.state, 0.8)
              )}, url("https://www.campinglacdusalagou.fr/wp-content/uploads/2025/06/activite-en-famille-au-camping-Montpellier.jpg")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        />
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <MKBox component="section" py={2}>
            <Container>
              <Grid container item xs={12} lg={6}>
                <MKTypography variant="h3" mb={6}>
                  Beneficios Verano 2025
                </MKTypography>
              </Grid>
              <Grid container spacing={3}>
                {BeneficiosVerano2025.map((item, index) => (
                  <Grid item xs={12} sm={6} lg={3} key={index}>
                    <Box sx={{ height: 380 }}>
                      <TransparentBlogCard
                        image={item.image}
                        title={item.title}
                        description={item.description}
                        action={{
                          type: "internal",
                          route: "/afiliate",
                          color: "info",
                          label: "Solicita tu afiliación",
                        }}
                      />
                    </Box>
                  </Grid>
                ))}
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                lg={3}
                sx={{
                  paddingTop: "2rem",
                }}
              >
                <BackgroundBlogCard
                  image={
                    "https://scontent-scl3-1.xx.fbcdn.net/v/t39.30808-6/476560425_1044755241014329_1856705899251695247_n.jpg?_nc_cat=109&ccb=1-7&_nc_sid=cc71e4&_nc_eui2=AeEUihS7LTfMTW6s6aT0CTfLtdNwgNQMJO2103CA1Awk7Y7hKGA7eE9jEK6DKyp8PMxL4d1dtUgXaGjMejjxPSDK&_nc_ohc=tTuVMSFGD3UQ7kNvwEYoqcX&_nc_oc=AdlE7HJ898S5bErSmpkX34nRCtmRwNw-0CZawkJuYdeDewWGrtXrc0ukXzZneW83GE8&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=l_ZAYgEkTseC1isoihF9mQ&oh=00_AfkqL9sn6h6R6pggCAn-P7x6QadqeMM5M5Y8txzBYuNLAQ&oe=69364860"
                  }
                  title="Disfruta del verano"
                  description="Relaja del trabajo y disfruta de un dia de familia en nuestro camping."
                  action={{
                    type: "internal",
                    route: "/afiliate",
                    label:
                      "Solo presentando tu carnet de afiliado, sino lo tienes afiliate, es sencillo",
                  }}
                />
              </Grid>
            </Container>
          </MKBox>
        </Card>

        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </MKBox>
    </>
  );
}
